import {processUwmCommand} from '@/services/uwm/uwmCommandProcessingService';

interface DispatchedEvent {
    type: string;
    data?: Record<string, unknown>;
}

declare global {
    var dispatch: (event: DispatchedEvent) => void;
}

globalThis.dispatch = (event) => {
    if (!event?.type) {
        console.warn('[UWM] dispatch: expected {type: string, data?: object}, got', event);

        return;
    }

    processUwmCommand({command: event.type, payload: event.data ?? {}});
};
